import { toCalendarDate, toTime } from "@internationalized/date";
import { FormSchemaDuration } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/formSchema";
import { FieldPath, FieldValues, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DropsDatePicker, Grid, TimePicker } from "shared/components/Spor";
import { EndsWith } from "shared/utils/objectUtils";

type DurationPickerProps<T extends FieldValues> = {
  durationsField: FieldPath<T> & EndsWith<"durations">;
  subField: "from_time" | "to_time";
};

export const DurationPicker = <T extends FieldValues>({
  durationsField: _durationsField,
  subField,
}: DurationPickerProps<T>) => {
  const durationsField = _durationsField as "durations";
  type FormWithDurations = { [durationsField]: FormSchemaDuration };

  const { setValue, getValues } = useFormContext<FormWithDurations>();

  const { t } = useTranslation();

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap="12px" width="100%">
      <TimePicker
        minHeight="54px"
        width="100%"
        label={t("Tid")}
        value={toTime(getValues(`${durationsField}.${subField}`))}
        minuteInterval={5}
        onValueChange={(time) => {
          if (time !== null) {
            setValue(`${durationsField}.${subField}.hour`, time.hour ?? 0);
            setValue(`${durationsField}.${subField}.minute`, time.minute ?? 0);
          }
        }}
      />
      <DropsDatePicker
        width="100%"
        minHeight="54px"
        variant="core"
        label={t("Dato")}
        value={toCalendarDate(getValues(`${durationsField}.${subField}`))}
        onValueChange={(date) => {
          if (date !== null) {
            setValue(`${durationsField}.${subField}.day`, date.day ?? 0);
            setValue(`${durationsField}.${subField}.month`, date.month ?? 0);
            setValue(`${durationsField}.${subField}.year`, date.year ?? 0);
          }
        }}
        withPortal={false}
      />
    </Grid>
  );
};
